import { Tariff } from "../entity/shared/Tariff.entity"

export interface TariffData {
	tariff:Tariff,
	data:string,
	voice:string,
	sms:string
}
